import CollapsibleMarkdown from '../CollapsibleMarkdown'

interface CollapsibleLodgingProps
{
    startingIsCollapsed: boolean,
    lodgingContent: string
}

const CollapsibleLodging = (props: CollapsibleLodgingProps) =>
{
    return(
        <CollapsibleMarkdown title={"Lodging"} startingIsCollapsed={props.startingIsCollapsed} content={props.lodgingContent} />
    );
}

export default CollapsibleLodging;